const localeMapping = {
  lng_en: 'en-us',
  lng_id: 'id',
  lng_ko: 'ko-kr',
  lng_th: 'th',
  lng_zh: 'zh-tw',
  'ja-JP': 'ja-jp',
  'vi-VN': 'vi-vn',
  'zh-TW': 'zh-tw'
}

const localeTopQuestion = {
  lng_en: 'Top Questions',
  lng_id: 'Pertanyaan Utama',
  lng_ko: '자주 묻는 질문',
  lng_th: 'คำถามที่พบบ่อย',
  lng_zh: '熱門問題',
  'ja-JP': '上位の質問',
  'vi-VN': 'Câu hỏi hàng đầu',
  'zh-TW': '熱門問題'
}

const topQuestionSlug = 'top-questions'

const topQuestion = {
  id: 1,
  name: localeTopQuestion[I18n.language],
  html_url: `/sections/${topQuestionSlug}`
}

export {
  localeMapping,
  topQuestionSlug,
  topQuestion
}
